require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-liverfoundation-symptoms.json") })
        }
      }, "path---article-liverfoundation-symptoms");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-liverfoundation-symptoms!./.cache/json/article-liverfoundation-symptoms.json
// module id = 347
// module chunks = 231608221292675